import Button from "@/components/bricks/button/Button";

export default function ErrorFallback({
  error,
  resetErrorBoundary,
}: {
  error: unknown;
  resetErrorBoundary?: () => void;
}) {
  const message = error instanceof Error ? error.message : String(error ?? "");
  return (
    <div>
      <h3>Runtime error</h3>
      <p>
        Check the console for more information that may be passed to the
        developers.
      </p>
      <p>
        <a href="https://developer.chrome.com/docs/devtools/open/">
          How to open the developer console in Chrome (link to chrome).
        </a>
      </p>
      <p>
        Generally, you can right click anywhere on the page and select the
        option to "inspect element". This opens the developer tools where there
        is a console that might give som extra information on the error.
      </p>
      {message && (
        <>
          <h4>Error message</h4>
          <p>{message}</p>
        </>
      )}

      {resetErrorBoundary && (
        <p>
          <Button onClick={resetErrorBoundary}>Go back</Button>
        </p>
      )}
    </div>
  );
}
